import { ICourse } from '@interfaces/ICourse';
import { IFormErrors } from '@interfaces/IFormsErrors';

export interface ICoursesViewState {
  list: { courses: ICourse[]; active_students_total?: number } | null;
  isLoading: boolean;
  errors: IFormErrors | null;
  detail: {
    data: ICourse | null;
    isLoading: boolean;
    errors: IFormErrors | null;
  };
  currentCourseId: number | null;
}

export const initialCoursesViewState: ICoursesViewState = {
  list: null,
  isLoading: false,
  errors: null,
  detail: {
    data: null,
    isLoading: false,
    errors: null,
  },
  currentCourseId: null,
};
